import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useStudioStore } from '@/store'
import { GlobalAnalyticsPage } from './GlobalAnalyticsPage'

export function CityAnalyticsPage() {
  const { partnerNumber, cityId } = useParams<{ partnerNumber: string; cityId: string }>()
  const selectedPartnerNumber = useStudioStore((state) => state.selectedPartnerNumber)
  const setSelectedPartnerNumber = useStudioStore((state) => state.setSelectedPartnerNumber)

  useEffect(() => {
    const parsed = Number(partnerNumber)
    const nextPartnerNumber = Number.isNaN(parsed) ? null : parsed
    if (selectedPartnerNumber !== nextPartnerNumber) {
      setSelectedPartnerNumber(nextPartnerNumber)
    }
  }, [partnerNumber, selectedPartnerNumber, setSelectedPartnerNumber])

  const parsedCityId = cityId ? Number(cityId) : null

  return <GlobalAnalyticsPage cityId={parsedCityId} />
}
